import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
// Import the navigation component for section switching and toggling the project panel
import Navigation from './components/Navigation';
// Import a visually styled rotated(Portfolio) section
import RotatedSection from './components/RotatedSection';
import Home from './components/Home';
import Resume from './projects/Resume';
import Website from './projects/Website';
import ProjectPanel from './components/ProjectPanel';
import NotFound from './pages/NotFound';
import './styles/Util.css';


const App: React.FC = () => {
  // State to control visibility of the ProjectPanel
  const [isPanelVisible, setIsPanelVisible] = useState(false);

  // State to track which section is currently active (e.g., "head" or "resume")
  const [activeSection, setActiveSection] = useState("head"); // Default to home

  // Function to toggle visibility of the ProjectPanel
  const togglePanel = () => setIsPanelVisible((prev) => !prev);

  return (
    <div className="container-fluid">
      {/* Navigation component with toggle function and section control props */}
      <Navigation 
        onToggle={togglePanel} 
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <main className="content">
        <div className="main-content">

          <Routes>
            <Route path="/" element={
              <div className={`section ${activeSection}`}>
                {activeSection === "head" && (
                  <>
                    <RotatedSection />
                    <Home />
                  </>
                )}
                <ProjectPanel  
                  isVisible={isPanelVisible} 
                  onToggle={togglePanel} 
                />
                {activeSection === "resume" && <Resume />}
                
                {activeSection === "website" && <Website 
                  url="https://an-nur-info-tech.com" 
                />}
              </div>
            } />

            <Route path="*" element={<NotFound />} />
            
          </Routes>

        </div>
      </main>
      
    </div>

  );
};

export default App;
